<template>
  <div class="video-player-wrapper">
    <video
        ref="videoPlayer"
        class="video-js vjs-theme-city vjs-fluid vjs-16-9"
        controls
        playsinline
        preload="metadata"
    />
  </div>
</template>

<script>
import videojs from 'video.js'

export default {
  name: 'VideoPlayer',

  props: {
    src: {
      type: String,
      required: true
    },

    type: {
      type: String,
      default: 'video/mp4'
    },

    poster: {
      type: String,
      default: ''
    },

    autoplay: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      player: null
    }
  },

  mounted() {
    this.initializePlayer()
  },

  beforeDestroy() {
    this.destroyPlayer()
  },

  watch: {
    src(newSrc) {
      this.updateSource(newSrc)
    },

    poster(newPoster) {
      if (this.player) {
        this.player.poster(newPoster || '')
      }
    }
  },

  methods: {
    initializePlayer() {
      if (!this.$refs.videoPlayer || !this.src) {
        return
      }

      this.player = videojs(this.$refs.videoPlayer, {
        controls: true,
        autoplay: this.autoplay,
        preload: 'metadata',
        fluid: true,
        responsive: true,
        poster: this.poster || undefined,
        sources: [
          {
            src: this.src,
            type: this.type
          }
        ]
      })
    },

    updateSource(newSrc) {
      if (!this.player || !newSrc) {
        return
      }

      this.player.pause()

      this.player.src({
        src: newSrc,
        type: this.type
      })

      this.player.load()
    },

    destroyPlayer() {
      if (this.player) {
        this.player.dispose()
        this.player = null
      }
    }
  }
}
</script>

<style scoped>
.video-player-wrapper {
  width: 100%;
}

.video-player-wrapper ::v-deep .video-js {
  width: 100%;
}
</style>
